import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

import {
  FiArrowLeft,
  FiArrowRight,
} from 'react-icons/fi';

import './styles.css';
import { UserService, SpaceService } from '../../../support/services/api';
import { setAuthData } from '../../../support/store/AuthReducer';
import {
  EmailStep, PasswordStep, Confirm, SignUp,
} from './Steps';

function Login({
  history, dispatch, retrievedToken, retrievedUserId, userData,
}) {
  const [step, setStep] = useState(1);
  const location = useLocation();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [email, setEmail] = useState('');
  const [cpf, setCpf] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [userExists, setUserExists] = useState(false);
  const [userId, setUserId] = useState('');
  const [token, setToken] = useState('');

  useEffect(() => {
    if (retrievedToken && retrievedUserId && userData) {
      setFirstName(userData.firstName);
      setLastName(userData.lastName);
      setWhatsapp(userData.whatsapp);
      setEmail(userData.email);
      setCpf(userData.cpf);
      setToken(retrievedToken);
      setUserId(retrievedUserId);
      setUserExists(true);

      if (location.state?.shouldConfirm) setStep(3);
    }
  }, [retrievedToken, retrievedUserId, userData]);

  async function nextStep() {
    switch (step) {
    case 1:
      if (!email) toast('Preencha o email', { type: toast.TYPE.WARNING });
      else checkEmail();
      break;

    case 2:
      if (!password) toast('Insira a senha', { type: toast.TYPE.WARNING });
      else loginUser();
      break;

    default:
      break;
    }
  }

  async function checkEmail() {
    UserService(true).getByEmail(email).then((users) => {
      if (users.length) {
        setUserExists(true);
        setWhatsapp(users[0].whatsapp);
        setFirstName(users[0].firstName);
        setLastName(users[0].lastName);
        setCpf(users[0].cpf);
        setPassword('');
        setStep(2);
      } else {
        setWhatsapp(''); // reset in case user comes back to step 1 and changes to a new email
        setFirstName('');
        setLastName('');
        setPassword('');
        setCpf('');
        setUserExists(false);
        setStep(3);
      }
    }).catch((err) => {
      if (err.response?.data?.statusCode === 400) toast(err.response.data.message, { type: toast.TYPE.WARNING });
      else toast('Ops. Algo deu errado. Tente novamente mais tarde.', { type: toast.TYPE.ERROR });
    });
  }

  async function loginUser() {
    try {
      const { token, userId } = await UserService(true).login({ email, password });

      setToken(token);
      setUserId(userId);
      setUserExists(true);

      const response = await SpaceService().getByUserId(userId);
      const { producers } = response;

      dispatch(setAuthData({
        userId, token, firstName, lastName, email, whatsapp, producers, cpf,
      }));

      if (location?.state?.previousPath) history.push(location.state.previousPath);
      else setStep(3);
    } catch (err) {
      toast('Senha incorreta.', { type: toast.TYPE.WARNING });
    }
  }

  return (
    <div className="checkout-container">
      <div className="step-scrollbox">
        {{
          1: <EmailStep email={email} setEmail={setEmail} />,
          2: userExists
            ? <PasswordStep email={email} setEmail={setEmail} password={password} setPassword={setPassword} setStep={setStep}/>
            : () => setStep(3),
          3: userExists
            ? (
              <Confirm
                email={email}
                firstName={firstName}
                setFirstName={setFirstName}
                lastName={lastName}
                setLastName={setLastName}
                whatsapp={whatsapp}
                setWhatsapp={setWhatsapp}
                cpf={cpf}
                setCpf={setCpf}
                setStep={setStep}
              />
            )
            : (
              <SignUp
                email={email}
                password={password}
                setPassword={setPassword}
                passwordConfirm={passwordConfirm}
                setPasswordConfirm={setPasswordConfirm}
                firstName={firstName}
                setFirstName={setFirstName}
                lastName={lastName}
                setLastName={setLastName}
                whatsapp={whatsapp}
                setWhatsapp={setWhatsapp}
                setStep={setStep}
                setUserExists={setUserExists}
              />
            ),
        }[step]}
      </div>
      {[1, 2].includes(step)
        && (
          <div className="next-step-bar-content">
            <button type="button" onClick={nextStep} className="next-step-bar">
              <FiArrowRight size={15} color="#FFF" strokeWidth="1" />
              <p className="next-step-bar-text">
                {{
                  1: 'Verificar email',
                  2: 'Login',
                }[step]}
              </p>
            </button>
          </div>
        )}
    </div>
  );
}

Login.propTypes = {
  history: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  retrievedToken: state.AuthReducer.token,
  retrievedUserId: state.AuthReducer.userId,
  userData: state.AuthReducer.userData,
});

export default connect(mapStateToProps)(withRouter(Login));
